import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setRuntimePerms } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=authed
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        let res;
        try {
          res = await api.get("/auth/me");
        } catch (e1) {
          if (e1.response?.status !== 401) throw e1;
          await api.post("/auth/refresh");
          res = await api.get("/auth/me");
        }
        const { data } = res;
        setRuntimePerms(data.role, data.permissions);
        setUser(data);
      } catch (e) {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setRuntimePerms(data.role, data.permissions);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) { /* noop */ }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
